module.exports = __webpack_public_path__ + "static/media/bulk-upload.afa955ca.png";